(function () {
	'use strict';

	angular
		.module('cacmConcurExpenseModule')
		.directive('cacmConcurExpense', directive);

	directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn', 'cacmService'];

	function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn, cacmService) {

		var directiveScope = _.clone(boxTmplScope);
		directiveScope.highlighting = '=';

		return {
			scope: directiveScope,
			template: boxTmplHtml,
			controller: ['$rootScope', '$scope', '$controller',
				function ($rootScope, $scope, $controller) {

					$scope.init = function () {
						$scope.dirCtxt = {
							isExpanded: false
						};
					};

					$scope.toggleIsExpanded = function () {
						$scope.dirCtxt.isExpanded = !$scope.dirCtxt.isExpanded;
					};

					if (_.isEmpty($scope.highlighting)) {
						$scope.isHighlighted = false;
					} else {
						$scope.isHighlighted = true;
					}

					// Flatten collections
					//if (!_.isUndefined($scope.boxModel.AttendeeIDs)) {
					//	$scope.boxModel.AttendeeIDs = $scope.boxModel.AttendeeIDs.join(", ");
					//}

					//if (!_.isUndefined($scope.boxModel.Attendees_FirstNames)) {
					//	$scope.boxModel.Attendees_FirstNames = $scope.boxModel.Attendees_FirstNames.join(", ");
					//}

					//if (!_.isUndefined($scope.boxModel.Attendees_LastNames)) {
					//	$scope.boxModel.Attendees_LastNames = $scope.boxModel.Attendees_LastNames.join(", ");
					//}

					//if (!_.isUndefined($scope.boxModel.Attendees_Companies)) {
					//	$scope.boxModel.Attendees_Companies = $scope.boxModel.Attendees_Companies.join(", ");
					//}

					// Box Template
					$scope.baseTemplatePath = '/app/shared/cacm/concurExpense/cacmConcurExpense.[Template].tpl.html';
					$controller('BoxTmplController', { $scope: $scope });
				}],
			link: function (scope, elem, attrs) {
				scope.init();
				boxTmplLinkFn(scope, elem, attrs);
			}
		}
	}
})();